export interface Feriado {
  data: string; // YYYY-MM-DD
  nome: string;
  tipo: 'nacional' | 'facultativo';
}

/** Domingo de Páscoa via algoritmo de Meeus/Jones/Butcher (calendário gregoriano). */
function calcularPascoa(ano: number): Date {
  const a = ano % 19;
  const b = Math.floor(ano / 100);
  const c = ano % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31);
  const dia = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(ano, mes - 1, dia));
}

function addDias(data: Date, dias: number): Date {
  const resultado = new Date(data);
  resultado.setUTCDate(resultado.getUTCDate() + dias);
  return resultado;
}

function toISODate(data: Date): string {
  return data.toISOString().slice(0, 10);
}

/** Feriados nacionais brasileiros (fixos + móveis a partir da Páscoa) para um ano. */
export function getFeriadosBrasil(ano: number): Feriado[] {
  const pascoa = calcularPascoa(ano);

  const feriados: Feriado[] = [
    { data: `${ano}-01-01`, nome: 'Confraternização Universal', tipo: 'nacional' },
    { data: `${ano}-04-21`, nome: 'Tiradentes', tipo: 'nacional' },
    { data: `${ano}-05-01`, nome: 'Dia do Trabalho', tipo: 'nacional' },
    { data: `${ano}-09-07`, nome: 'Independência do Brasil', tipo: 'nacional' },
    { data: `${ano}-10-12`, nome: 'Nossa Senhora Aparecida', tipo: 'nacional' },
    { data: `${ano}-11-02`, nome: 'Finados', tipo: 'nacional' },
    { data: `${ano}-11-15`, nome: 'Proclamação da República', tipo: 'nacional' },
    { data: `${ano}-11-20`, nome: 'Consciência Negra', tipo: 'nacional' },
    { data: `${ano}-12-25`, nome: 'Natal', tipo: 'nacional' },
    { data: toISODate(addDias(pascoa, -48)), nome: 'Carnaval (segunda)', tipo: 'facultativo' },
    { data: toISODate(addDias(pascoa, -47)), nome: 'Carnaval', tipo: 'facultativo' },
    { data: toISODate(addDias(pascoa, -2)), nome: 'Sexta-feira Santa', tipo: 'nacional' },
    { data: toISODate(pascoa), nome: 'Páscoa', tipo: 'facultativo' },
    { data: toISODate(addDias(pascoa, 60)), nome: 'Corpus Christi', tipo: 'facultativo' },
  ];

  return feriados.sort((a, b) => a.data.localeCompare(b.data));
}

/** Feriados nacionais para um intervalo de anos (inclusive). */
export function getFeriadosBrasilIntervalo(anoInicio: number, anoFim: number): Feriado[] {
  const anos: number[] = [];
  for (let ano = anoInicio; ano <= anoFim; ano += 1) anos.push(ano);
  return anos.flatMap((ano) => getFeriadosBrasil(ano));
}
